/* eslint-disable no-underscore-dangle */
/* eslint-disable no-undef */
// import api from "../../../config/api"
import {
  removeStorage,
  getStorage,
} from '../../../utils/functions/localstorage';
import { ME_GET, ME_RESET } from '../types';
import api from '../../../utils/functions/api';
import { showAlert } from '../../../utils/functions/globalDialog';
import { derivePermissionsFromRoles } from '../../../utils/functions/accessRight';

export const meGet = () => async (dispatch) => {
  const rememeber = JSON.parse(getStorage('remember'));
  try {
    const { data } = await api.get(
      `${process.env.REACT_APP_API_URL}/user/${rememeber.uid._id}`,
    );

    // Merge DB permissions with permissions derived from system_role.allowed_menus
    const dbPerms = data.userData?.permissions || {};
    const derivedPerms = derivePermissionsFromRoles(data.userData?.system_role);
    const mergedPerms = {};
    new Set([...Object.keys(dbPerms), ...Object.keys(derivedPerms)])
      .forEach((k) => { mergedPerms[k] = !!(dbPerms[k] || derivedPerms[k]); });

    dispatch({
      type: ME_GET,
      payload: {
        ...data,
        userData: { ...data.userData, permissions: mergedPerms },
      },
    });
  } catch (error) {
    console.error(error);
    await removeStorage('token');
    await removeStorage('remember');
    showAlert('โทเค็นหมดอายุ');
    window.location.reload();
    dispatch({ type: ME_RESET });
    throw new Error(error);
  }
};

export const meReset = () => async (dispatch) => {
  dispatch({ type: ME_RESET, payload: null });
};
